@if (uiState().isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_recalc_time_entries_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>Recalc Time Entries</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <h3 fxFlex="100" class="pr-1 text-[14px]">
            This function uses the rates specified on the matter to calculate the new price. As such
            you need to change the rates before recalculating the Time Entries.
          </h3>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <h3 fxFlex="100" class="pr-1 text-[14px]">
            <strong>
              This process will prompt you for each Time Entry to make sure you want to change it.
            </strong>
          </h3>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxFlex="1 0 auto">
          <div><strong>Date</strong></div>
          <div>{{ workItem()?.ITEMDATE }}</div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" class="full-width pr-1" fxFlex="100">
            <mat-label>Additional Text</mat-label>

            <textarea
              matInput
              [value]="$safeNavigationMigration(workItem()?.ADDITIONALTEXT)"
              readonly
              rows="4"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxFlex="1 0 auto"
          style="padding-bottom: 25px"
        >
          <div><strong>Quantity</strong></div>
          <div>{{ workItem()?.QUANTITY }}</div>
          <div>{{ workItem()?.QUANTITYTYPE }}</div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
          <div fxFlex="13" class="pr-1"></div>
          <div>
            <strong>Current Price</strong>
          </div>
          <div><strong>New Price</strong></div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
          <div fxFlex="10" class="pr-1">
            <strong>Ex-GST</strong>
          </div>
          <div>{{ $safeNavigationMigration(workItem()?.PRICE) | currency }}</div>
          <div>
            {{ $safeNavigationMigration(getSelectedWIPNewPrice()?.PRICE) | currency }}
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
          <div fxFlex="10" class="pr-1">
            <strong>GST</strong>
          </div>
          <div>{{ $safeNavigationMigration(workItem()?.GST) | currency }}</div>
          <div>
            {{ $safeNavigationMigration(getSelectedWIPNewPrice()?.GST) | currency }}
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
          <div fxFlex="10" class="pr-1">
            <strong>Inc-GST</strong>
          </div>
          <div>{{ $safeNavigationMigration(workItem()?.PRICEINCGST) | currency }}</div>
          <div>
            {{ $safeNavigationMigration(getSelectedWIPNewPrice()?.PRICEINCGST) | currency }}
          </div>
        </div>
      </form>
    </div>
    @if (!uiState().isWipData) {
      <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <div fxLayout="column" fxFlex="1 0 auto" name="form">
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <h3 fxFlex="100" class="pr-1 text-[14px]">
              <strong>There are no Entries to change</strong>
            </h3>
          </div>
        </div>
      </div>
    }
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (uiState().isWipData) {
      <button
        matButton="filled"
        class="mat-accent"
        (click)="changePrice()"
        cdkFocusInitial
        [disabled]="uiState().isspiner"
      >
        @if (uiState().isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Change entry
      </button>

      <button matButton="tonal" (click)="skipTimeEntry()" cdkFocusInitial>Don't Change</button>

      <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
    } @else {
      <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Ok</button>
    }
  </mat-dialog-actions>
</div>
